import Requisicao from './RequisicaoService';

class UsuarioClienteService {
    static async cliente(token) {
        return Requisicao.get('usuario-cliente/'+ token);
    }
}

export default UsuarioClienteService;